import $ from 'jquery';

export const handleAccordian=()=>{
    $(document).ready(function () {
        $( '.fp-faq' ).on( 'click', 'h2', function() {
            var $faq = $( this ).closest( '.fp-faq' );
            $faq.find( '.toggle-content' ).slideToggle( 500, function() {
                $faq.toggleClass( 'active' );
            } );
        } );

        $( '.fp-accordion' ).on( 'click', 'h2, .icons', function() {
            var $faq = $( this ).closest( '.fp-accordion' );
            $faq.find( '.toggle-content' ).slideToggle( 500, function() {
                $faq.toggleClass( 'active' );
            } );
        } );
      });
}
export const handleTestimonial=()=>{
   
    if ($('#testimonial-slider2').length) {
		$('#testimonial-slider2').owlCarousel({
			loop: true,
			margin: 30,
			nav: false,
			smartSpeed: 500,
			autoplay: 4000,
			items: 1,
			dots: true,
			navText: ['<span class="fa fa-angle-left"></span>', '<span class="fa fa-angle-right"></span>'],
			responsive: {
				0: {
					items: 1
				},
				600: {
					items: 1
				},
				800: {
					items: 1
				},
				1024: {
					items: 2
				},
				1200: {
					items: 2
				}
			}
		});
	}
}